import { render } from "./oti_show.vue?vue&type=template&id=136e36b0&scoped=true"
import script from "./oti_show.vue?vue&type=script&lang=js"
export * from "./oti_show.vue?vue&type=script&lang=js"

import "./oti_show.vue?vue&type=style&index=0&id=136e36b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136e36b0"]])

export default __exports__